export default __webpack_public_path__ + "static/media/khayitbek.3bdf1be1.jpg";